import { Component } from '@angular/core';
import { SheetService } from '../sheet.service';
declare var $: any;

@Component({
    selector: 'sheet-widget',
    templateUrl: 'sheet-widget.component.html'
})
export class SheetWidgetComponent {

    private currentWorkbookName: string;

    constructor(private _sheetService: SheetService) {
        this.currentWorkbookName = '';
    }

    public show(): boolean {
        return this._sheetService.getSheetCount() > 0;
    }

    private workbookNameValid(): boolean {
        let regEx = new RegExp(/^(\w+\s?)*\w$/);
        return regEx.test(this.currentWorkbookName);
    }

    private getSheetCount(): number {
        return this._sheetService.getSheetCount();
    }

    private saveWorkbook(): void {
        $('#sheet-widget-modal').modal('open');
    }

    private download(): void {
        this._sheetService.downloadWorkbook(this.currentWorkbookName);
        this.close();
    }

    private cancel(): void {
        this._sheetService.clearExport();
    }

    public close(): void {
        this.currentWorkbookName = '';
        $('#sheet-widget-modal').modal('close');
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/sheet-export-import/sheet-widget/sheet-widget.component.ts